import { SxProps } from '@mui/material';
import { greyText, yellow } from 'app/components/ThemeProvider/colors';

export const container: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const line: SxProps = {
  width: '100%',
  height: '8px',
  background: yellow,
};

export const header: SxProps = {
  p: '29px 728px',
};

export const mainText: SxProps = {
  fontSize: '28px',
  mt: '30px',
  fontWeight: '600',
};

export const secondaryText: SxProps = {
  fontSize: '18px',
  fontWeight: '600',
  mt: '12px',
  color: greyText,
  textAlign: 'center',
  maxWidth: '385px',
};
